"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.procurementDialogSchema = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var collectionsRef_1 = require("common/db/collectionsRef");
var officesList_1 = require("common/global/officesList");
var usersList_1 = require("common/global/usersList");
var formik_1 = require("formik");
var map_1 = __importDefault(require("lodash/map"));
var moment_1 = __importDefault(require("moment"));
var react_1 = __importStar(require("react"));
var firestore_1 = require("react-firebase-hooks/firestore");
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var Yup = __importStar(require("yup"));
var Option = antd_1.Select.Option;
exports.procurementDialogSchema = Yup.object().shape({
    itemLineCode: Yup.string().required(),
    office: Yup.string().required(),
    // officeType: Yup.string().required(),
    quantity: Yup.number()
        .min(1)
        .required(),
    requiredDateToDelivery: Yup.date().required(),
    IRRising: Yup.date().required(),
    expectedDateToDelivery: Yup.date().required(),
    user: Yup.string().required(),
});
function AddProcurementPlanItem(props) {
    var _this = this;
    var _a, _b, _c;
    var _d = (0, react_1.useState)(props.docId === "notFromBudget" ? undefined : props.docId), itemLineCode = _d[0], setItemLineCode = _d[1];
    var t = (0, react_i18next_1.useTranslation)().t;
    var params = (0, react_router_dom_1.useParams)();
    var projectId = params.projectId;
    var budgetLineItemsSnapshot = (0, firestore_1.useCollection)(collectionsRef_1.budgetLineItemsRef.where("projectId", "==", projectId))[0];
    var budgetLineItemDocSnapshot = (0, firestore_1.useDocument)(collectionsRef_1.budgetLineItemsRef.doc(itemLineCode || "not"))[0];
    var budgetLineItemData = budgetLineItemDocSnapshot === null || budgetLineItemDocSnapshot === void 0 ? void 0 : budgetLineItemDocSnapshot.data();
    var modalState = props.modalState, setModalState = props.setModalState, docId = props.docId;
    var formProps = (0, formik_1.useFormik)({
        validationSchema: exports.procurementDialogSchema,
        initialValues: {
            itemLineCode: docId === "notFromBudget" ? "" : docId,
            office: "",
            // officeType: '',
            quantity: 0,
            requiredDateToDelivery: (0, moment_1.default)(),
            IRRising: (0, moment_1.default)(),
            expectedDateToDelivery: (0, moment_1.default)(),
            user: "",
        },
        onSubmit: function (values) { return __awaiter(_this, void 0, void 0, function () {
            var itemLineData, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        itemLineData = budgetLineItemDocSnapshot.data();
                        return [4 /*yield*/, collectionsRef_1.procurementPlansRef.add({
                                projectId: projectId,
                                itemLineCode: itemLineCode,
                                productType: itemLineData.productType,
                                productName: itemLineData.productName,
                                productDescription: itemLineData.productDescription,
                                officeId: values.office,
                                // officeType: values.officeType,
                                itemDescription: itemLineData.productName,
                                productId: itemLineData.productId,
                                budgetLineId: itemLineData.budgetLineId,
                                budgetLineItemId: budgetLineItemDocSnapshot.id,
                                unitId: itemLineData.productUnitId,
                                quantity: values.quantity,
                                unitCost: itemLineData.unitCost,
                                totalCost: values.quantity * itemLineData.unitCost,
                                requiredDateToDelivery: values.requiredDateToDelivery.toDate(),
                                IRRising: values.IRRising.toDate(),
                                expectedDateToDelivery: values.expectedDateToDelivery.toDate(),
                                userId: values.user,
                            })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, collectionsRef_1.budgetLineItemsRef.doc(itemLineCode).update({
                                plannedQuantity: itemLineData.plannedQuantity + values.quantity,
                            })];
                    case 2:
                        _a.sent();
                        antd_1.message.success(t("alerts.success"));
                        setModalState(false);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        antd_1.message.success(t("alerts.error"));
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); },
    });
    if (!budgetLineItemsSnapshot) {
        return (0, jsx_runtime_1.jsx)(antd_1.Spin, {});
    }
    var MAX = !(budgetLineItemData === null || budgetLineItemData === void 0 ? void 0 : budgetLineItemData.maxQuantity)
        ? 0
        : (budgetLineItemData === null || budgetLineItemData === void 0 ? void 0 : budgetLineItemData.maxQuantity) - (budgetLineItemData === null || budgetLineItemData === void 0 ? void 0 : budgetLineItemData.plannedQuantity);
    var dateFormat = "YYYY/MM/DD";
    return ((0, jsx_runtime_1.jsxs)(antd_1.Drawer, __assign({ title: "Add to Procurement Plan", width: 500, open: modalState, onClose: function () { return setModalState(false); } }, { children: [(0, jsx_runtime_1.jsxs)(antd_1.Form, __assign({ labelCol: { span: 8 }, wrapperCol: { span: 16 } }, { children: [docId === "notFromBudget" ? ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                formProps.getFieldMeta("itemLineCode").touched) &&
                                formProps.errors.itemLineCode &&
                                "error", help: (formProps.submitCount ||
                                formProps.getFieldMeta("itemLineCode").touched) &&
                                formProps.errors.itemLineCode, label: t("budget.BudgetLineItem"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.Select, __assign({ value: itemLineCode, style: { width: "80%", margin: "3% 5%" }, showSearch: true, optionFilterProp: "children", onChange: function (e) {
                                    formProps.setFieldValue("itemLineCode", e);
                                    setItemLineCode(e);
                                } }, { children: budgetLineItemsSnapshot === null || budgetLineItemsSnapshot === void 0 ? void 0 : budgetLineItemsSnapshot.docs.map(function (item) {
                                    return (0, jsx_runtime_1.jsx)(Option, __assign({ value: item.id }, { children: item.data().code }));
                                }) })) })) })) : ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("h3", { children: "Line Code:  ".concat((_c = (_b = (_a = budgetLineItemsSnapshot === null || budgetLineItemsSnapshot === void 0 ? void 0 : budgetLineItemsSnapshot.docs) === null || _a === void 0 ? void 0 : _a.find(function (e) { return e.id === itemLineCode; })) === null || _b === void 0 ? void 0 : _b.data()) === null || _c === void 0 ? void 0 : _c.code) }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                            formProps.getFieldMeta("office").touched) &&
                            formProps.errors.office &&
                            "error", help: (formProps.submitCount ||
                            formProps.getFieldMeta("office").touched) &&
                            formProps.errors.office, label: t("common.office"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.Select, __assign({ style: { width: "80%", margin: "3% 5%" }, showSearch: true, optionFilterProp: "children", onChange: function (e) {
                                formProps.setFieldValue("office", e);
                            } }, { children: (0, map_1.default)(officesList_1.globalOfficesData, function (item) {
                                return ((0, jsx_runtime_1.jsx)(Option, __assign({ value: item.id }, { children: item.name }), item.id));
                            }) })) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                            formProps.getFieldMeta("quantity").touched) &&
                            formProps.errors.quantity &&
                            "error", help: (formProps.submitCount ||
                            formProps.getFieldMeta("quantity").touched) &&
                            formProps.errors.quantity, label: t("common.quantity"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.InputNumber, { type: "number", style: { width: "80%", margin: "3% 5%" }, min: 0, max: MAX, value: formProps.values.quantity, onChange: function (e) { return formProps.setFieldValue("quantity", e); } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                            formProps.getFieldMeta("requiredDateToDelivery").touched) &&
                            formProps.errors.requiredDateToDelivery &&
                            "error", help: (formProps.submitCount ||
                            formProps.getFieldMeta("requiredDateToDelivery").touched) &&
                            formProps.errors.requiredDateToDelivery, label: t("budget.requiredDateToDelivery"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.DatePicker, { value: formProps.values.requiredDateToDelivery, format: dateFormat, onChange: function (e) {
                                return formProps.setFieldValue("requiredDateToDelivery", e);
                            }, style: { width: "80%", margin: "3% 5%" } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                            formProps.getFieldMeta("IRRising").touched) &&
                            formProps.errors.IRRising &&
                            "error", help: (formProps.submitCount ||
                            formProps.getFieldMeta("IRRising").touched) &&
                            formProps.errors.IRRising, label: t("budget.IRRising"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.DatePicker, { value: formProps.values.IRRising, format: dateFormat, onChange: function (e) { return formProps.setFieldValue("IRRising", e); }, style: { width: "80%", margin: "3% 5%" } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                            formProps.getFieldMeta("expectedDateToDelivery").touched) &&
                            formProps.errors.expectedDateToDelivery &&
                            "error", help: (formProps.submitCount ||
                            formProps.getFieldMeta("expectedDateToDelivery").touched) &&
                            formProps.errors.expectedDateToDelivery, label: t("budget.expectedDateToDelivery") }, { children: (0, jsx_runtime_1.jsx)(antd_1.DatePicker, { value: formProps.values.expectedDateToDelivery, format: dateFormat, onChange: function (e) {
                                return formProps.setFieldValue("expectedDateToDelivery", e);
                            }, style: { width: "80%", margin: "3% 5%" } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount || formProps.getFieldMeta("user").touched) &&
                            formProps.errors.user &&
                            "error", help: (formProps.submitCount || formProps.getFieldMeta("user").touched) &&
                            formProps.errors.user, label: t("budget.personInCharge"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.Select, __assign({ style: { width: "80%", margin: "3% 5%" }, showSearch: true, optionFilterProp: "children", onChange: function (e) {
                                formProps.setFieldValue("user", e);
                            } }, { children: (0, map_1.default)(usersList_1.globalUsersData, function (item) {
                                return ((0, jsx_runtime_1.jsx)(Option, __assign({ value: item.id }, { children: item.name }), item.id));
                            }) })) }))] })), (0, jsx_runtime_1.jsxs)("div", __assign({ style: {
                    textAlign: "right",
                } }, { children: [(0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ onClick: function () { return setModalState(false); }, style: { marginRight: 8 } }, { children: "Cancel" })), (0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ onClick: function () {
                            formProps.handleSubmit();
                        }, type: "primary", loading: formProps.isSubmitting }, { children: "Submit" }))] }))] })));
}
exports.default = AddProcurementPlanItem;
